import { useRef, useEffect, useCallback } from 'react';
import { isEqual } from 'lodash';
import { useStore } from '@tmsw/powerups.store';
import { usePageConfig } from '@tmsw/powerups.config.page.provider';

export type UseVieConfigProps = {
  video?: string[] | string;
  toyVideo?: string;
  captions?: string;
  descriptions?: string;
  legal?: string;
  metadata?: string;
  skipChapter?: string | null;
  templates?: {
    [key: string]: (...args: any) => any; // TODO: clean up these types, prob Element but to be safe
  };
  overlays?: any;
  [key: string]: any;
};

export function useVieConfig(props?: UseVieConfigProps) {
  // state hooks
  const currentPage = useStore((state) => state.currentPage);
  const setCurrentVIEConfig = useStore((state) => state.setCurrentVIEConfig);
  const currentVIEConfig = useStore((state) => state.currentVIEConfig);
  // const setIsPauseBtnDisplayed = useStore((state) => state.setIsPauseBtnDisplayed);
  // const isPauseBtnDisplayed = useStore((state) => state.isPauseBtnDisplayed);
  const setPlay = useStore((state) => state.setPlay);
  const setIsPlaying = useStore((state) => state.setIsPlaying);
  const setMetadataTrack = useStore((state) => state.setMetadataTrack);
  const setCurrentCueMetadata = useStore(
    (state) => state.setCurrentCueMetadata
  );
  const setOverridingChapter = useStore((state) => state.setOverridingChapter);
  const setDescriptionsReading = useStore(
    (state) => state.setDescriptionsReading
  );

  const { goToPage } = usePageConfig();

  const resetVIE = useCallback(() => {
    console.trace('resetVIE!!!!!!!');
    setPlay(false);
    setIsPlaying(false);
    setCurrentVIEConfig(null);
    setMetadataTrack(null);
    setCurrentCueMetadata(null);
    setDescriptionsReading(false);
    setOverridingChapter(null);
  }, [
    setPlay,
    setIsPlaying,
    setCurrentVIEConfig,
    setMetadataTrack,
    setCurrentCueMetadata,
    setDescriptionsReading,
    setOverridingChapter,
  ]);

  const goToPageAndCleanup = (targetPage) => {
    resetVIE();
    goToPage(targetPage);
  };

  const goToNextPageAndCleanup = () => {
    goToPageAndCleanup(currentPage + 1);
  };

  const goToPrevPageAndCleanup = () => {
    goToPageAndCleanup(currentPage - 1);
  };

  const config = props ?? null;
  const vieConfigRef = useRef(config);

  const updateVieConfig = useCallback(
    (newConfig: UseVieConfigProps) => {
      // console.trace(config);
      vieConfigRef.current = { ...vieConfigRef.current, ...newConfig };
      if (isEqual(vieConfigRef.current, currentVIEConfig)) {
        console.log('EQUAL VIE CONFIG, SKIPPING UPDATE!');
        return;
      }
      console.log('updating!', {
        oldConfig: currentVIEConfig,
        newConfig: vieConfigRef.current,
      });
      setCurrentVIEConfig(vieConfigRef.current);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentVIEConfig]
  );

  /**
   * Initial Setter
   */
  useEffect(() => {
    if (typeof config === 'undefined' || !config || config === null) return;
    updateVieConfig(config);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   if (typeof currentVIEConfig === "undefined" || !currentVIEConfig || currentVIEConfig === null) return;
  //   if (currentVIEConfig.pauseBtn !== isPauseBtnDisplayed) {
  //     console.log('Setting isPauseBtnDisplayed from config :: new, old', currentVIEConfig.pauseBtn, isPauseBtnDisplayed);
  //     setIsPauseBtnDisplayed(currentVIEConfig.pauseBtn);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentVIEConfig, isPauseBtnDisplayed]);

  return {
    vieConfigRef,
    updateVieConfig,
    goToPage: goToPageAndCleanup,
    goToNextPage: goToNextPageAndCleanup,
    goToPrevPage: goToPrevPageAndCleanup,
  };
}
